/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {Loner} from "../Loner";
import {BonusFeatureData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BonusFeatures";
import {GameClientConfiguration} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";
import {ResourceCreator} from "../resourcecreator/ResourceCreator";
import {TextureHelper} from "../utils/TextureHelper";

export class LonerIntroConfig implements GameIntroViewConfig {

    private _notAllowedFeatures:string[] = [];

    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x483106, //Default 0x000000
            backgroundAlpha : 0.0, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff
        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xWaysInfectious : true,
        xWays : false,
        xNudge : false,
        xPays : false,
        xBomb : false,
        xSize : false,
        xSplit : true,
        xBet : true,
        xCluster : false,
        xMount : false,
        xCap : false,
        xBizarre : false,
        xZone : false,
        xGod : true,
        snowflake : false,
        volatility : Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader:ImgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBgBg", "resources/images/bgBg.jpg");
        imgLoader.add("bgLogo", "resources/images/logo.jpg");
        imgLoader.add("bgLeft", "resources/images/bgLeft.jpg");
        imgLoader.add("bgRight", "resources/images/bgRight.jpg");
        imgLoader.add("bgTop", "resources/images/bgTop.jpg");
        imgLoader.add("bgBottom", "resources/images/bgBottom.jpg");
        imgLoader.add("bgCenter", "resources/images/bgCenter.png");
        imgLoader.add("feature1", "resources/images/Intro_Feature_1.png");
        imgLoader.add("feature2", "resources/images/Intro_Feature_2.png");
        imgLoader.add("feature3", "resources/images/Intro_Feature_3.png");
        imgLoader.add("feature4", "resources/images/Intro_Feature_4.png");
        imgLoader.add("feature5", "resources/images/Intro_Feature_5.png");
        imgLoader.add("feature6", "resources/images/Intro_Feature_6.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() : void {

        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();
        this.logo = new PIXI.Container();

        const featureSprite1:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
        featureSprite1.anchor.set(0.5, 0.5);
        featureSprite1.position.y -= 20;
        const featureSprite2:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
        featureSprite2.anchor.set(0.5, 0.5);
        featureSprite2.position.y -= 15;
        const featureSprite3:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));
        featureSprite3.anchor.set(0.5, 0.5);
        featureSprite3.position.y -= 15;
        const featureSprite4:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature4"));
        featureSprite4.anchor.set(0.5, 0.5);
        featureSprite4.position.y -= 10;

        this.pages = [
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage()
        ];

        this.pages[0].addChild(featureSprite1);
        this.pages[1].addChild(featureSprite2);
        this.pages[2].addChild(featureSprite3);
        this.pages[3].addChild(featureSprite4);

        this.background = new PIXI.Container();
        const bgSprite:PIXI.Sprite = new PIXI.Sprite(this.createBackground());
        bgSprite.anchor.set(0.5, 0.5);
        bgSprite.position.y += 196;
        this.borderTop.addChild(bgSprite);

        const bgBgSprite:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBgBg"));
        bgBgSprite.anchor.set(0.5, 0.5);
        bgBgSprite.position.y -= 17;
        this.background.addChild(bgBgSprite);
    }

    private createBackground():PIXI.Texture{
        const bgContainer:PIXI.Container = new PIXI.Container();
        const bgTopContainer:PIXI.Container = new PIXI.Container();
        const bgLeft:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("bgLeft"));
        const bgRight:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("bgRight"));
        const bgTop:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("bgTop"));
        const bgBottom:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("bgBottom"));
        const bgCenter:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("bgCenter"));
        const bgLogo:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("bgLogo"));

        bgContainer.addChild(bgLeft);
        bgTopContainer.addChild(bgTop);
        bgTopContainer.position.x = bgLeft.width;
        bgLogo.position.y = 504;
        bgLogo.position.x = 320;
        bgTopContainer.addChild(bgLogo);
        bgContainer.addChild(bgTopContainer);
        bgBottom.position.x = bgLeft.width;
        bgBottom.position.y = bgLeft.height - bgBottom.height;
        bgContainer.addChild(bgBottom);
        bgRight.position.x = (bgLeft.width + bgTop.width);
        bgContainer.addChild(bgRight);
        bgCenter.position.x = bgLeft.width;
        bgCenter.position.y = bgTop.height;
        bgContainer.addChild(bgCenter);

        const bgTexture:PIXI.Texture = TextureHelper.createRenderedTextureFromContainer(bgContainer);
        bgContainer.destroy({children : true});

        return bgTexture;
    }

    public gameClientConfigurationApplied(rules:GameClientConfiguration) {
        this.addPages();
    }

    private addPages():void {
        const notAllowedFeatures:BonusFeatureData[] = Loner.apiPlugin.bonusFeatures.notAllowedFeatures;
        for(let i:number = 0; i < notAllowedFeatures.length; i++) {
            this._notAllowedFeatures.push(notAllowedFeatures[i].name);
        }

        if(this._notAllowedFeatures.includes("GOD_MODE") == false) {
            const godModeImage:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature5"));
            godModeImage.anchor.set(0.5);
            const godModePage:SlideShowPage = new SlideShowPage();
            godModePage.addChild(godModeImage)
            this.pages.splice(this.pages.length, 0, godModePage);
        }
        if(this._notAllowedFeatures.includes("BOOSTED_BET") == false) {
            const betBoostImage:PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature6"));
            betBoostImage.anchor.set(0.5);
            const betBoostpage:SlideShowPage = new SlideShowPage();
            betBoostpage.addChild(betBoostImage)
            this.pages.splice(this.pages.length, 0, betBoostpage);
        }
    }
}